// extracted by mini-css-extract-plugin
module.exports = {"paginationTotal":"supply-and-scheduling__PaginationTotalCount__paginationTotal"};